import React from 'react'
import MuiTable from '../../../Forms/SharedComponents/containers/MuiTable'
import { TABLA_VENTA_A_EXPORTADOR_ACTUAL } from '../../../../config/tables'

function VentaAExportadoresActualView () {
  return (
    <MuiTable id={TABLA_VENTA_A_EXPORTADOR_ACTUAL} />
  )
}

export default VentaAExportadoresActualView
